
import React, { } from 'react';
import './ButtonVariantCentr.css';



const ButtonVariantCentr = ({ name, isShow }) => {

  return (
    <>

      <div className="container_buttonVariant_center">
        {name}
      </div>
    </>

  )
}

export default ButtonVariantCentr;